import Footer from "./Footer";
import BottomHeader from "../components/themes/fullScreen/Header"
const guests = [
  {
    name: "Burkhard Mackensen, MD, PhD, FASE",
    title: "MD, PhD, FASE",
    desc: "Chair and Allan J. Treuer Endowed Professorship, Adjunct Professor of Medicine; Director of Interventional Echocardiography, Department of Anesthesiology & Pain, Medicine University of Washington School of Medicine Seattle, WA, USA",
    icon: "images/Guest Faculty/Burkhard Mackensen.png",
  },
  {
    name: "Mario Ernesto Montealegre Gallegos, MD",
    title: "MD",
    desc: "Assistant Professor of Clinical Anesthesiology, Department of Anesthesia, Critical Care Medicine, Yale School of Medicine New Haven, CT, USA",
    icon: "images/Guest Faculty/Mario Montealegre-Gallegos.png",
  },
  {
    name: "Andrew Maslow, MD",
    title: "MD",
    desc: "Professor of Anesthesiology, Vice-chair (Faculty Development), Brown University, Providence, RI, USA",
    icon: "images/Guest Faculty/Andrew Maslow.png",
  },
  {
    name: "Kendra Derry, MD",
    title: "MD FASE",
    desc: "Assistant Professor of Anesthesia & Perioperative Medicine, Staff Anesthesiologist & Education Lead, Department of Anesthesia & Perioperative Medicine Queen's University School of Medicine Kingston, ON, CAN",
    icon: "images/Guest Faculty/Kendra Derry.png",
  },
];
const courseDirectors = [
  {
    name: "Feroze Mahmood, MD, FASE",
    title: "MD FASE",
    desc: "Professor of Anesthesia, Harvard Medical School; Network Chief - Cardiac Anesthesia, Beth Israel Deaconess Medical Center.",
    icon: "images/Course Directors/Feroze Mahmood.png",
  },
  {
    name: "Ruma Bose, MD",
    title: "MD",
    desc: "Assistant Professor of Anesthesia, Harvard Medical School; Program Director of Cardiothoracic Anesthesia Fellowship, Beth Israel Deaconess Medical Center",
    icon: "images/Course Directors/Ruma Bose.png",
  },
  {
    name: "Aidan Sharkey, MD",
    title: "MD",
    desc: "Instructor in Anesthesia, Beth Israel Deaconess Medical Center, Harvard Medical School",
    icon: "images/Course Directors/Aidan Sharkey.png",
  },
  {
    name: "Sohail Mahboobi, MD, FASA",
    title: "MD, FASA",
    desc: "Assistant Professor of Anesthesiology, Tufts University School of Medicine; Vice-chair (Education) Lahey Hospital & Medical Center",
    icon: "images/Course Directors/Mahboobi Sohail.png",
  },
];
const courseFaculty = [
  {
    name: "Anastasia Katsiampoura, MD",
    title: "MD",
    desc: "Instructor in Anesthesia, Beth Israel Deaconess Medical Center, Harvard Medical School",
    icon: "images/Course Faculty/Anastasia Katsiampoura.png",
  },
  {
    name: "Bharath Rathakrishnan, MD",
    title: "MD",
    desc: "Instructor in Medicine, Division of Cardiology, Beth Israel Deaconess Medical Center, Harvard Medical School",
    icon: "images/Course Faculty/Bharath Rathakrishnan.png",
  },
  {
    name: "Charles Nyman,  MBChB",
    title: "MD",
    desc: "Instructor in Anesthesia, Brigham and Women's Hospital, Harvard Medical School",
    icon: "images/Course Faculty/Charles Nyman.png",
  },
  {
    name: "Daniel McGrail, MD",
    title: "MD",
    desc: "Staff Anesthesiologist, Beth Israel Deaconess Medical Center, Harvard Medical School",
    icon: "images/Course Faculty/Daniel McGrail.png",
  },
  {
    name: "Douglas Shook,  MD, FASE",
    title: "MD",
    desc: "Assistant Professor of Anaesthesia, Harvard Medical school; Division Chief of Cardiac Anaesthesia, Brigham and Women's Hospital",
    icon: "images/Course Faculty/Douglas Shook.png",
  },
  {
    name: "Faraz Mahmood, MD",
    title: "MD",
    desc: "Cardiac Anesthesia Fellow, Beth Israel Deaconess Medical Center",
    icon: "images/Course Faculty/Faraz Mahmood.png",
  },
  {
    name: "Marie France Pouline, MD",
    title: "MD",
    desc: "Assistant Professor of Medicine Division of Cardiology, Beth Israel Deaconess Medical Center, Harvard Medical School",
    icon: "images/Course Faculty/Marie France Pouline.png",
  },
  {
    name: "Mark Robitaille, MD",
    title: "MD",
    desc: "Instructor in Anesthesia, Beth Israel Deaconess Medical Center, Harvard Medical School",
    icon: "images/Course Faculty/Mark Robitaille.png",
  },
  {
    name: "James Haering, MD",
    title: "MD",
    desc: "Assistant Professor of Anaesthesia, Harvard Medical School; Vice-chair (Clinical Affairs), Department of Anesthesia, Beth Israel Deaconess Medical Center",
    icon: "images/Course Faculty/James Michael Hearing.png",
  },
  {
    name: "Sankalp Sehgal, MD",
    title: "MD",
    desc: "Instructor in Anesthesia, Beth Israel Deaconess Medical Center, Harvard Medical School",
    icon: "images/Course Faculty/Sankalp Sehgal.png",
  },
  {
    name: "Shweta Yemul Golhar, MDr",
    title: "MD",
    desc: "Instructor in Anesthesia, Beth Israel Deaconess Medical Center, Harvard Medical School",
    icon: "images/Course Faculty/Shweta Yemul Golhar.png",
  },
  {
    name: "Stanton Shernan, MD, FASE",
    title: "MD",
    desc: "Benjamin G. Covino Professor of Anaesthesia, Harvard Medical School; Director, Cardiac Anesthesia Service, Brigham and Women's Hospital",
    icon: "images/Course Faculty/Stanton Shernan.png",
  },
];
const Guest = () => {
    return (
                <>
                <BottomHeader></BottomHeader>
        <section id="guest" className="section bg-light p-0">
          <div className="container mb-5 mt-5">
            <h2  style={{color:"#AE2A2F"}} className="text-10 fw-600 text-center wow fadeInUp">
              Course Directors
            </h2>
            {/* Heading end*/}
            <div className="row gy-5 mt-5">
              {courseDirectors.length > 0 &&
                courseDirectors.map((service, index) => (
                  <div className="col-sm-6 col-lg-3 wow fadeInUp" key={index}>
                    <div className="featured-box text-center px-md-4">
                      <div className="featured-box-icon text-primary text-13">
                        {" "}
                        <img width={250} height={250}
                          className="img-fluid rounded d-block"
                          src={service.icon}
                          alt="pic"
                          // style={{border:"4px solid grey"  }}
                        />
                        {/* <i className={service.icon} /> */}
                      </div>
                      <p className="fw-600 mb-0">{service.name}</p>
                      {/* <p className="fw-600 mb-3 text-muted">{service.title}</p> */}
                      <p className="text-muted mb-0" style={{fontSize:"12px"}}>{service.desc} </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="container mb-5">
            {/* Heading */}
            <h2 style={{color:"#AE2A2F"}} className="text-10 fw-600 text-center mb-5 wow fadeInUp">
              Guest Speakers
            </h2>
            {/* Heading end*/}
            <div className="row gy-5 mt-5">
              {guests.length > 0 &&
                guests.map((service, index) => (
                  <div className="col-sm-6 col-lg-3 wow fadeInUp" key={index}>
                    <div className="featured-box text-center px-md-4">
                      <div className="featured-box-icon text-primary text-13">
                        {" "}
                        <img width={250} height={250}
                          className="img-fluid rounded d-block"
                          src={service.icon}
                          alt="pic"
                          // style={{border:"4px solid grey"  }}
                        />
                        {/* <i className={service.icon} /> */}
                      </div>
                      <p className="fw-600 mb-0">{service.name}</p>
                      {/* <p className="fw-600 mb-3 text-muted">{service.title}</p> */}
                      <p className="text-muted mb-0" style={{fontSize:"12px"}}>{service.desc} </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="container mb-5">
            {/* Heading */}
            <h2 style={{color:"#AE2A2F"}} className="text-10 fw-600 text-center mb-5 wow fadeInUp">
              Harvard Medical School Course Faculty
            </h2>
            {/* Heading end*/}
            <div className="row gy-5 mt-5">
              {courseFaculty.length > 0 &&
                courseFaculty.map((service, index) => (
                  <div className="col-sm-6 col-lg-3 wow fadeInUp" key={index}>
                    <div className="featured-box text-center px-md-4">
                      <div className="featured-box-icon text-primary text-13">
                        {" "}
                        <img width={250} height={250}
                          className="img-fluid rounded d-block"
                          src={service.icon}
                          alt="pic"
                          // style={{border:"4px solid grey"  }}
                        />
                        {/* <i className={service.icon} /> */}
                      </div>
                      <p className="fw-600 mb-0">{service.name}</p>
                      {/* <p className="fw-600 mb-3 text-muted">{service.title}</p> */}
                      <p className="text-muted mb-0" style={{fontSize:"12px"}}>{service.desc} </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>

        </section>
<Footer></Footer>
        </>
        
      );
};

export default Guest;
